export const environment = {
  production: false,
  apiUrl: 'https://sky-dap-dev-finance-fa-cognos.azurewebsites.net/api', /*Function app Api URL*/
  functionKey: 'Pp3rgXVHcbG_q5s4GjPBRGALJ0ecKVF4Aopje0Lv0hRaAzFuRgv8SQ==',
  appUrl: 'https://dev.cognos-controller-archive.middleware.sky' /*Angular Web app URL*/
};
